<template>
    <div>
        <div class="row">
            <div class="col">
                <h1 class="text-primary">Produtos Varejo</h1>
            </div>
        </div>
        <b-card>
            <div class="row mt-3">
                <div class="col-6">
                    <b-button variant="primary" size="sm" class="mr-2" @click="voltar"><i class="fas fa-arrow-left"></i>
                        Voltar
                    </b-button>
                </div>
            </div>
            <b-row class="mt-3" align-v="end">
                <b-col cols="2">
                    <label>Produto</label>
                    <b-form-input v-model="codigo" placeholder="Código ou Descrição" size="sm"
                        @keyup.enter="getProdutos()" />
                </b-col>
                <b-col cols="2">
                    <label for="">Tipo de Produto</label>
                    <b-form-select :options="['VA', 'AV', 'TODOS']" v-model="tipo" size="sm"></b-form-select>
                </b-col>
                <b-col>
                    <label for="">Mostrar Indisponíveis</label>
                    <b-form-checkbox v-model="indisponiveis"></b-form-checkbox>
                </b-col>
                <b-col class="text-left">
                    <b-button variant="primary" size="sm" @click="getProdutos()">
                        <i class="fas fa-search"></i> Buscar
                    </b-button>
                    <b-button variant="success" size="sm" @click="exportar()">
                        <i class="fas fa-file-excel"></i> Exportar
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3" align-v="end">
                <b-col cols="8">
                    <b-pagination v-model="currentPage" :total-rows="showProdutos.length" :per-page="perPage" align="fill"
                        size="sm" class="my-0" />
                </b-col>
                <b-col class="text-center">
                    Total: {{ showProdutos.length }}
                </b-col>
                <b-col>
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
                        title="Por Página" />
                </b-col>
            </b-row>
            <div class="row mt-3">
                <b-table hover striped :current-page="currentPage" :per-page="perPage" :items="showProdutos"
                    :busy="isLoading" :fields="header" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection" stacked="md" show-empty small>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando ...</strong>
                        </div>
                    </template>
                    <!-- COLUNA EDITAR -->
                    <template #cell(id)="data">
                        <b-button title="Detalhar" size="sm" variant="primary" @click="editar(data.item)">
                            <i class="fas fa-eye"></i>
                        </b-button>
                    </template>
                    <template #cell(disponivel)="data">
                        <b-badge v-if="data.item.disponivel" variant="success">Disponível</b-badge>
                        <b-badge v-if="!data.item.disponivel" variant="danger">Bloqueado</b-badge>
                    </template>
                </b-table>
            </div>
        </b-card>

        <!-- Modal Cadastro de Produto -->
        <b-modal v-model="modalProduto" size="xl" :title="produto.descricao">
            <b-overlay :show="loadingModal" rounded="sm">
                <div class="card p-3">
                    <div class="row">
                        <div class="col-4">
                            <label>Código do Produto</label>
                            <b-form-input type="text" v-model="produto.codigo" placeholder="Código do produto"
                                v-mask="'XXXXXX'" disabled />
                        </div>
                        <div class="col">
                            <label>Descrição</label>
                            <b-form-input v-model="produto.descricao" disabled />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col">
                            <label>Marca</label>
                            <b-form-input v-model="produto.marca" disabled />
                        </div>
                        <div class="col">
                            <label>Qtd. Caixa</label>
                            <b-form-input type="text" v-model="produto.qtd_caixa" :readonly="produto.caixa_mista"
                                disabled placeholder="Quantidade Caixa" v-mask="'XX'" />
                        </div>
                        <div class="col">
                            <label>Preço</label>
                            <b-form-input v-model="produto.preco_venda" :readonly="produto.caixa_mista" v-money="money"
                                disabled />
                        </div>
                    </div>
                    <b-row v-if="dataModal" class="mt-3">
                        <b-col>
                            <b> Estoque:</b> {{ dataModal.produto.estoque }}
                        </b-col>
                        <b-col>
                            <b>Utilizado:</b> {{ getUtilizado }}
                        </b-col>
                        <b-col>
                            <b>Saldo:</b> {{ getSaldo }}
                        </b-col>
                    </b-row>
                    <b-row v-if="dataModal" class="mt-3">
                        <b-table :items="dataModal.data" :fields="fieldsPropostas" striped small hover
                            :busy="loadingModal">
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Buscando...</strong>
                                </div>
                            </template>

                            <template #cell(proposta)="row">
                                <a :href="'/venda-direta/proposta/' + row.item.id + '/edit'" target="_blank">{{
                                    row.item.id
                                    }}</a>
                            </template>
                            <template #cell(pedido)="row">
                                <a v-if="row.item.pedido" href="#" @click="imprimirPedido(row.item.pedido.id)">{{
                                    row.item.pedido.id }}</a>
                            </template>
                        </b-table>
                    </b-row>
                    <!-- <div class="row mt-3" v-if="produto.caixa_mista">
                    <div class="col">
                        <h5 class="text-primary"> Informe os dados da Caixa mista.</h5>
                    </div>
                </div>
                <div class="row mt-3" v-if="produto.caixa_mista">
                    <div class="col">
                        <label>Código Caixa mista 1</label>
                        <b-form-input type="text" v-model="produto.codigo_mx1" placeholder="Código do produto"
                            v-mask="'XXXXXX'" />
                    </div>
                    <div class="col">
                        <label>Qtd. itens na caixa</label>
                        <b-form-input type="text" v-model="produto.qtd_mx1" placeholder="Código do produto"
                            v-mask="'XX'" @keyup="somaQtdMista" />
                    </div>
                    <div class="col">
                        <label>Preço</label>
                        <b-form-input type="text" v-model="produto.preco_mx1" placeholder="Preço" v-money="money"
                            @keyup="somaPrecoMista" />
                    </div>
                </div> -->
                    <!-- <div class="row mt-3" v-if="produto.caixa_mista">
                    <div class="col">
                        <label>Código Caixa Mista 2</label>
                        <b-form-input type="text" v-model="produto.codigo_mx2" placeholder="Código do produto"
                            v-mask="'XXXXXX'" />
                    </div>
                    <div class="col">
                        <label>Qtd. itens na caixa</label>
                        <b-form-input type="text" v-model="produto.qtd_mx2" placeholder="Código do produto"
                            v-mask="'XX'" @keyup="somaQtdMista" />
                    </div>
                    <div class="col">
                        <label>Preço</label>
                        <b-form-input type="text" v-model="produto.preco_mx2" placeholder="Preço" v-money="money"
                            @keyup="somaPrecoMista" />
                    </div>
                </div> -->
                </div>
            </b-overlay>
            <template #modal-footer="{ ok }">
                <!-- <b-button title="Bloquear Produto" size="sm" variant="warning" v-if="produto.id" :disabled="loading"
                    @click="bloquearProduto()">{{ produto.disponivel ? "Bloquear" : "Desbloquear" }}</b-button>
                <b-button size="sm" variant="primary" @click="saveProduto()" :disabled="loading">
                    <span v-if="loading">
                        <b-spinner small type="grow"></b-spinner>
                    </span> Salvar
                </b-button> -->
                <b-button size="sm" variant="danger" @click="ok()">
                    Fechar
                </b-button>
            </template>
        </b-modal>

        <!-- Modal Importar Produtos -->
        <b-modal v-model="modalImportar" size="lg" title="Importar Produtos">
            <div class="card p-3">
                <div class="col">
                    <b-form-file v-model="planilha" :state="Boolean(planilha)" @change="readFile"
                        placeholder="Selecione uma planilha" drop-placeholder="ou arraste até aqui"></b-form-file>
                </div>
            </div>
            <template #modal-footer="{ ok }">
                <b-button size="sm" variant="primary" @click="importar()" :disabled="loading">
                    <span v-if="loading">
                        <b-spinner small type="grow"></b-spinner>
                    </span> Salvar
                </b-button>
                <b-button size="sm" variant="danger" @click="ok()">
                    Cancelar
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {
    VMoney
} from 'v-money';
export default {
    name: 'produtos-varejo',
    directives: {
        money: VMoney
    },
    data() {
        return {
            indisponiveis: false,
            tipo: 'VA',
            modalProduto: false,
            loadingModal: false,
            produtos: [],
            fieldsPropostas: [
                {
                    key: 'proposta',
                    label: 'Proposta',
                    class: 'text-center',
                },
                {
                    key: 'pedido',
                    label: 'Pedido',
                    class: 'text-center',
                },
                {
                    key: 'distribuidor',
                    label: 'Cliente',
                    formatter: (value, x, item) => {
                        return item.distribuidor ? (item.distribuidor.codigo + ' - ' + item.distribuidor.nome) :
                            (item.prospecto && item.prospecto.distribuidor ?
                                (item.prospecto.distribuidor.codigo + ' - ' + item.prospecto.distribuidor.nome) :
                                "")
                    },
                },
                {
                    key: 'tipo_proposta',
                    label: 'Tipo',
                    class: 'text-center',
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    class: 'text-center',
                    formatter: (value, x, item) => {
                        return item.itens.reduce((acc, el) => acc += parseInt(el.quantidade), 0)
                    },
                },
                {
                    key: 'status',
                    label: 'Status',
                    class: 'text-center',
                    formatter: (value, x, item) => {
                        return item.pedido ? item.pedido.status : item.status
                    },
                },
                {
                    key: 'created_at',
                    label: 'Data',
                    class: 'text-center',
                    formatter: (value, x, item) => {
                        if (item.pedido) {
                            return moment(item.pedido.created_at).format("DD/MM/YYYY HH:mm:ss");
                        } else {
                            return moment(item.created_at).format("DD/MM/YYYY HH:mm:ss");
                        }
                    },
                },
            ],
            money: {
                decimal: ',',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            header: [
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true
                },
                {
                    key: 'disponivel',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'preco_venda',
                    label: "Preço R$",
                    formatter: (value) => {
                        return value ? value.replace('.', ',') : "";
                    },
                    sortable: true
                },
                {
                    key: 'saldo',
                    label: "Saldo",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: 'id',
                    label: ''
                }
            ],
            isLoading: false,
            loading: false,
            produto: {
                id: null,
                codigo: '',
                qtd_caixa: 0,
                descricao: '',
                marca: '',
                ncm: '',
                ean: '',
                preco_venda: 0,
                protheus: '',
                caixa_mista: false,
                qtd_mx1: 0,
                qtd_mx2: 0,
                preco_mx1: 0,
                preco_mx2: 0,
                codigo_mx1: '',
                codigo_mx2: ''
            },
            // totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [15, 20, 30, 50],
            sortBy: 'codigo',
            sortDesc: false,
            sortDirection: 'asc',
            codigo: '',
            descricao: '',
            planilha: null,
            modalImportar: false,
            dataModal: null
        }
    },
    computed: {
        getSaldo() {
            return this.dataModal.produto.estoque - this.getUtilizado;
        },
        getUtilizado() {
            let val = this.dataModal.data.reduce((acc, el) => acc += el.itens.reduce((acci, il) => acci += parseInt(il.quantidade), 0), 0)
            return val
        },
        showProdutos() {
            let data = this.produtos;
            const vm = this;
            if (vm.codigo !== "") {
                data = data.filter(el => {
                    return el.codigo.toLowerCase().indexOf(vm.codigo.toLowerCase()) > -1 || el.descricao.toLowerCase().indexOf(vm.codigo.toLowerCase()) > -1;
                })
            }
            if (vm.tipo !== 'TODOS') {
                data = data.filter(el => {
                    return el.codigo.toLowerCase().indexOf(vm.tipo.toLowerCase()) > -1;
                })
            }

            if (!vm.indisponiveis) {
                data = data.filter(el => el.disponivel)
            }
            return data
        }
    },
    methods: {
        imprimirPedido(id) {
            window.open("/venda-direta/pedidos/" + id + "/imprimir", "_blank");
        },
        bloquearProduto() {
            const vm = this;
            vm.loading = true;
            axios
                .post("/venda-direta/produtos/bloquear", vm.produto)
                .then((response) => {
                    if (response) {
                        vm.loading = false;
                        vm.getProdutos();
                        vm.modalProduto = !vm.modalProduto;
                        return vm.$swal({
                            icon: 'success',
                            title: response.data
                        })
                    }
                })
                .catch((erro) => {
                    console.log(erro);
                    vm.loading = false;
                })
        },
        voltar() {
            window.location.href = "/venda-direta/"
        },

        somaQtdMista() {
            this.produto.qtd_caixa = 0;
            let mx1 = parseInt(this.produto.qtd_mx1);
            let mx2 = parseInt(this.produto.qtd_mx2);
            this.produto.qtd_caixa = parseInt(mx1 + mx2)
        },
        somaPrecoMista() {
            this.produto.preco_venda = 0;
            let Px1 = parseFloat(this.produto.preco_mx1.replace(",", "."));
            let Px2 = parseFloat(this.produto.preco_mx2.replace(",", "."));
            this.produto.preco_venda = parseFloat(Px1 + Px2).toFixed(2).toString().replace('.', ',');
        },
        showModalPlanilha() {
            this.modalImportar = !this.modalImportar;
        },
        importar() {
            const vm = this;
            $(".loading").show();
            if (!this.planilha) {
                return vm.$swal("Arquivo inválido", "Selecione um arquivo do tipo CSV para importar", "error");
            }
            axios.post("/venda-direta/produtos/importar", {
                arquivo: this.planilha
            }).then((response) => {
                vm.showModalPlanilha();
                $(".loading").hide();
                vm.getProdutos();
            }).catch((error) => {
                $(".loading").hide();
                console.log(error);
                let e = error.response.data;
                vm.$swal("Houve um erro ao importar", e.msg ? e.msg : "erro desconhecido", "error");
            })
        },
        readFile(event) {
            const file = event.target.files[0];
            const vm = this
            var promiseVar = new Promise(async (resolve, reject) => {
                try {
                    var reader = new FileReader();
                    reader.readAsText(file);
                    reader.onload = function (e) {
                        vm.planilha = e.target.result;
                        resolve('complete');
                    };
                } catch (error) {
                    console.error(error);
                    reject("There must be an error");
                }
            });
        },
        saveProduto() {
            //this.somaQtdMista();
            //this.somaPrecoMista();

            if (this.produto.codigo === "") {
                return this.$swal("Ops", "informe o código do produto", "error");
            }
            /*if (this.produto.protheus === ""){
                return this.$swal("Ops","informe o código do produto no PROTHEUS","error");
            }*/
            if (this.produto.descricao === "") {
                return this.$swal("Ops", "informe a descrição do produto", "error");
            }
            if (this.produto.preco_venda === "") {
                return this.$swal("Ops", "informe o preço de venda do produto", "error");
            }
            this.loading = true;
            const vm = this;
            axios.post("/venda-direta/produtos", this.produto).then((response) => {
                vm.modalProduto = false;
                vm.loading = false;
                vm.produto = {
                    id: null,
                    codigo: '',
                    descricao: '',
                    marca: '',
                    ncm: '',
                    ean: '',
                    preco_venda: 0,
                    protheus: '',
                    caixa_mista: false,
                    qtd_mx1: 0,
                    qtd_mx2: 0,
                    preco_mx1: 0,
                    preco_mx2: 0,
                    codigo_mx1: '',
                    codigo_mx2: ''
                }
                vm.getProdutos();
            }).catch((error) => {
                console.log("error", error);
                vm.$swal("Ops", "Erro ao salvar produto", "error");
                vm.loading = false;
            })
        },
        exportar() {
            window.open('/venda-direta/produtos/listarTodos?exportar=true', '_blank');
        },
        getProdutos() {
            const vm = this;
            vm.isLoading = true
            axios.get("/venda-direta/produtos/listarTodos").then((response) => {
                response.data.forEach((el) => {
                    const qtdped = el.qtd_pedido ? parseInt(el.qtd_pedido) : 0
                    const qtdprop = el.qtd_proposta ? parseInt(el.qtd_proposta) : 0
                    el.saldo = el.estoque - (qtdped + qtdprop);
                })
                vm.produtos = response.data;
                // vm.totalRows = vm.produtos.length
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                vm.isLoading = false;
            });
        },
        addProduto() {
            this.produto = {
                id: null,
                codigo: '',
                qtd_caixa: 0,
                descricao: '',
                marca: '',
                ncm: '',
                ean: '',
                preco_venda: 0,
                protheus: '',
                caixa_mista: false,
                qtd_mx1: 0,
                qtd_mx2: 0,
                preco_mx1: 0,
                preco_mx2: 0,
                codigo_mx1: '',
                codigo_mx2: ''
            },
                this.modalProduto = !this.modalProduto
        },
        editar(obj) {
            const vm = this;
            vm.dataModal = null;
            this.produto = obj;
            this.modalProduto = !this.modalProduto;
            vm.loadingModal = true;
            axios.get('/venda-direta/getEstoque/' + obj.id)
                .then((response) => {
                    vm.dataModal = response.data
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.loadingModal = false
                })

        }
    },
    mounted() {
        this.getProdutos();
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/varejo/produtos/index.vue